import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardBody, CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getWaterRightsList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditWaterRightsModal from './Add_Edit/AddEditWaterRightsModal';
import DeleteWaterRightsModal from './Delete/DeleteWaterRights';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const WaterRightsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const [dataWaterRights, setDataWaterRights] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete WaterRights
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);


	const selectorWaterRights = createSelector(
		state => state.WaterRights,
		water_rights => ({
			water_rightsList: water_rights.water_rightsList,
			isLoadingList: water_rights.isLoadingList,
			isWaterRightsSuccess: water_rights.isWaterRightsSuccess,
			error: water_rights.error,
			isAdding: water_rights.isAdding,
			isAdded: water_rights.isAdded,
			isAddError: water_rights.isAddError,
			isUpdating: water_rights.isUpdating,
			isUpdated: water_rights.isUpdated,
			isUpdateError: water_rights.isUpdateError,
			isDeleting: water_rights.isDeleting,
			isDeleted: water_rights.isDeleted,
			isDeleteError: water_rights.isDeleteError,
		})
	);

	const { water_rightsList, isLoadingList } = useSelector(selectorWaterRights);

	useEffect(() => {
		dispatch(getWaterRightsList());
	}, []);

	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = water_rights => {
		setDataWaterRights(water_rights);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = water_rights => {
		setDataWaterRights(water_rights);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'water_rights',
				columnDefType: 'display',
				width: 5,
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={() => {
													const water_rightsData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(water_rightsData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const water_rightsData =
														cellProps.row.original;
													handleClickDelete(water_rightsData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Empresa', accessorKey: 'company_id' },
			{ header: 'Estado', accessorKey: 'water_rights_status_id' },
			{ header: 'Tipo', accessorKey: 'water_rights_type_id' },
			{ header: 'Uso del agua', accessorKey: 'water_use_id' },
			{ header: 'Estado del uso del agua', accessorKey: 'water_use_status_id' },
			{ header: 'Fuente de agua', accessorKey: 'water_source_id' },
			{ header: 'Efluente', accessorKey: 'effluent' },
			{ header: 'Afluente', accessorKey: 'influent' },
			{ header: 'Caudal anual promedio', accessorKey: 'average_annual_flow' },
			{ header: 'Valor de caudal anual promedio', accessorKey: 'average_annual_flow_value' },
			{ header: 'Unidad de caudal anual promedio', accessorKey: 'average_annual_flow_water_unit_id' },
			{ header: 'Caudal ecológico promedio', accessorKey: 'average_ecological_flow' },
			{ header: 'Valor de caudal ecológico promedio', accessorKey: 'average_ecological_flow_value' },
			{ header: 'Unidad de caudal ecológico promedio', accessorKey: 'average_ecological_flow_water_unit_id' },
			{ header: 'Fecha de inscripción de obras', accessorKey: 'date_registration_works' },
			{ header: 'Inicio de transmisión de reporte', accessorKey: 'start_transmission_report' },
			{ header: 'Nombre de resolución', accessorKey: 'resolution_name' },
			{ header: 'Región de la resolución', accessorKey: 'resolution_region_id' },
			{ header: 'CBR', accessorKey: 'cbr_id' },
			{ header: 'Páginas CBR', accessorKey: 'cbr_pages' },
			{ header: 'Número CBR', accessorKey: 'cbr_number' },
			{ header: 'Año CBR', accessorKey: 'cbr_year' },
			{ header: 'Número CPA', accessorKey: 'cpa_number' },
			{ header: 'Año CPA', accessorKey: 'cpa_year' },
			
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataWaterRights({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Derecho de Agua
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={water_rightsList || []}
								isLoadingData={isLoadingList}
								nameFile={'derechos_de_agua'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataWaterRights({});
											handleToggleModal();
										},
										title: 'Crear Derecho de Agua'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditWaterRightsModal
				dataWaterRights={dataWaterRights}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteWaterRightsModal
				dataWaterRights={dataWaterRights}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default WaterRightsList;
